import React from 'react';

const STEPS = [
  { id: 'blog_stage_start', label: 'Worker started' },
  { id: 'blog_stage_variables_ready', label: 'Variables ready' },
  { id: 'blog_stage_prompt_rendered', label: 'Prompt rendered' },
  { id: 'blog_stage_llm_call_start', label: 'Calling model' },
  { id: 'blog_stage_llm_call_end', label: 'Model responded' },
  { id: 'blog_stage_s3_raw_write_end', label: 'S3 raw write complete' },
  { id: 'blog_stage_parse_start', label: 'Parsing output' },
  { id: 'blog_stage_parse_end', label: 'Parsed' },
  { id: 'blog_stage_s3_write_end', label: 'S3 write complete' },
  { id: 'blog_stage_save_start', label: 'Saving output' },
  { id: 'blog_stage_done', label: 'Completed' },
];

export function RunProgress({ jobStatus, jobProgress }: { jobStatus: string | null; jobProgress: any[] }) {
  if (!jobStatus && (!jobProgress || jobProgress.length === 0)) return null;
  const events = new Set((jobProgress || []).map((p: any) => p?.event).filter(Boolean));
  const lastEvent = jobProgress?.length ? jobProgress[jobProgress.length - 1]?.event : null;
  return (
    <div className="mt-2 rounded border bg-gray-50 px-3 py-2 text-xs text-gray-700">
      <div className="flex items-center justify-between">
        <div>Run status: {jobStatus || 'unknown'}</div>
        {lastEvent && <div className="text-gray-500">Last: {lastEvent}</div>}
      </div>
      <div className="mt-2 grid grid-cols-2 gap-x-4 gap-y-1">
        {STEPS.map(step => {
          const done = events.has(step.id);
          return (
            <div key={step.id} className={`flex items-center gap-2 ${done ? 'text-green-700' : 'text-gray-500'}`}>
              <span>{done ? '✓' : '•'}</span>
              <span>{step.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
